import { render, staticRenderFns } from "./DashboardClientProperty.vue?vue&type=template&id=a27de2b8&"
import script from "./DashboardClientProperty.vue?vue&type=script&lang=ts&"
export * from "./DashboardClientProperty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a27de2b8')) {
      api.createRecord('a27de2b8', component.options)
    } else {
      api.reload('a27de2b8', component.options)
    }
    module.hot.accept("./DashboardClientProperty.vue?vue&type=template&id=a27de2b8&", function () {
      api.rerender('a27de2b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientDashboard/DashboardClientProperty.vue"
export default component.exports